export default __webpack_public_path__ + "static/media/DeleteButton.36e3c16b.jpg";